import React from "react";
import FormattedMessageString from "../../../basics/FormattedMessageString";
import EventFormError from "../../errors/EventFormError";
import EventOption from "../../../../models/event/EventOption";
import { PriceHelper } from "../../../../helpers";

class OptionTextFormComponent {
    static fields(params = {}) {
        return [{
            type: "row",
            children: [
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.form.title",
                        type: "text",
                        name: 'title',
                        customFeedback: EventFormError,
                        formErrorName: "title"
                    }]
                },
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.form.description",
                        type: "textarea",
                        name: 'description',
                        optional: true,
                        customFeedback: EventFormError,
                        formErrorName: "description"
                    }]
                },
                {
                    type: "col",
                    md: 6,
                    fields: [{
                        title: "CMS.Event.option.form.price",
                        type: "text",
                        name: 'price',
                        customFeedback: EventFormError,
                        formErrorName: "price",
                        customProps: {
                            prepend: {
                                name: 'currency',
                                disabled: true,
                                options: Object.keys(PriceHelper.getCurrencyList()).map(currency => (
                                    <option value={currency} key={currency} dangerouslySetInnerHTML={{ __html: PriceHelper.getCurrencySign(currency) }} />
                                ))
                            }
                        }
                    }]
                },
                {
                    type: "col",
                    md: 6,
                    fields: [{
                        title: "CMS.Event.option.form.price_type",
                        type: "select",
                        name: 'price_type',
                        options: [EventOption.PRICE_TYPE_FIXED, EventOption.PRICE_TYPE_PER_DAY].map(type => ({ value: type, label: <FormattedMessageString id={'CMS.Event.option.form.price_type.' + type} /> })),
                        customFeedback: EventFormError,
                        formErrorName: "price_type"
                    }]
                },
                // Only for a group with multiple choices
                params.quantity ? {
                    type: "col",
                    md: 6,
                    fields: [{
                        title: "CMS.Event.option.form.max_quantity",
                        type: "number",
                        name: 'max_quantity',
                        message: "CMS.Event.option.form.max_quantity.message",
                        customFeedback: EventFormError,
                        formErrorName: "max_quantity"
                    }]
                } : null,
                params.quantity ? { type: "col", md: 6, fields: [] } : null,
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.form.is_default",
                        type: "switch",
                        name: 'is_default',
                        customFeedback: EventFormError,
                        formErrorName: "is_default"
                    }],
                    messageId: "CMS.Event.option.form.is_default.message"
                },
                {
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Event.option.form.active",
                        type: "switch",
                        name: 'active',
                        customFeedback: EventFormError,
                        formErrorName: "active"
                    }]
                }
            ].filter(Boolean)
        }];
    }
}

export default OptionTextFormComponent;
